exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-4f649d50]{border-radius:10px}.table td[data-v-4f649d50],.table th[data-v-4f649d50]{vertical-align:middle;font-size:.85rem}.badge[data-v-4f649d50]{font-size:.78rem;padding:4px 8px}", ""]);

// exports
